import { render, staticRenderFns } from "./GroupFunction.vue?vue&type=template&id=2036bb5e"
import script from "./GroupFunction.vue?vue&type=script&lang=js"
export * from "./GroupFunction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports